module.exports = __webpack_public_path__ + "2f9325c9319a67edd7786932f0693608.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/PPN_ASSETS/WalletCard_2023_MSH_fr.jpg
// module id = 1564
// module chunks = 0